<div class="card flex justify-content-center">
  <p-card [header]="pageTitle"
          [style]="{ width: '360px' }"
          class="flex justify-content-center">

    <form [formGroup]="editServiceProductForm">
      <div>
        <label for="title"
               class="block text-900 font-medium mb-2">Title</label>
        <input id="title"
               formControlName="title"
               required
               type="text"
               placeholder="Enter Title"
               class="p-inputtext p-component p-element w-full mb-3">
        <label for="description"
               class="block text-900 font-medium mb-2">Description</label>
        <input id="description"
               formControlName="description"
               required
               type="text"
               placeholder="Enter Description"
               class="p-inputtext p-component p-element w-full mb-3">

        <label for="itemNumber"
               class="block text-900 font-medium mb-2">Item Number</label>
        <input id="itemNumber"
               formControlName="itemNumber"
               required
               type="text"
               placeholder="Enter Item Number"
               class="p-inputtext p-component p-element w-full mb-3">

        <div class="flex justify-content-between align-items-center">
          <label for="productTypeItem"
                 class="block text-900 font-medium mb-2">Type</label>
          <p-dropdown class="block text-900 font-medium mb-2"
                      formControlName="serviceProductTypeItem"
                      [options]="serviceProductTypePDropdownItems"
                      optionLabel="value"
                      placeholder="Service Type"></p-dropdown>

          <label for="uomTypeItem"
                 class="block text-900 font-medium mb-2">Uom</label>
          <p-dropdown class="block text-900 font-medium mb-2"
                      formControlName="uomTypeItem"
                      [options]="serviceProductUomTypePDropdownItems"
                      optionLabel="value"
                      placeholder="Uom Type"></p-dropdown>
        </div>
        <label for="price"
               class="block text-900 font-medium">Price
        </label>
        <p-inputNumber id="price"
                       formControlName="price"
                       required
                       placeholder="Price"
                       class="p-inputtext p-component p-element w-full my-2"
                       inputId="currency-us"
                       mode="currency"
                       currency="USD"
                       locale="en-US"> </p-inputNumber>
      </div>
    </form>

    <ng-template pTemplate="footer">
      <div class="flex justify-content-between">
        <p-button class="btn btn-primary"
                  (click)="onSaveServiceProduct()"
                  [disabled]="!editServiceProductForm.valid">Save</p-button>
        <p-button class="btn btn-primary"
                  (click)="onCancelServiceProduct()">Cancel</p-button>
      </div>
    </ng-template>
  </p-card>
</div>
